import { gql } from '@src/lib/gql'

/**
 * L19 chat panel: the session thread plus the existing direct thread between the
 * viewer and the counterparty (`directChatThreadWithCurrentUser`, read-only —
 * never pass `createIfEmpty`). Kept out of the 4s room poll on purpose.
 */
export const ADVISOR_SESSION_CHAT = gql`
  query AdvisorSessionChat($advisorSessionId: String!) {
    advisorSession(advisorSessionId: $advisorSessionId) {
      id
      advisorSessionId
      statusKey
      currentUserRole
      chatThreadId
      chatThread {
        id
        threadId
      }
      expertUser {
        id
        userId
        directChatThreadWithCurrentUser {
          id
          threadId
        }
      }
      seekerUser {
        id
        userId
        directChatThreadWithCurrentUser {
          id
          threadId
        }
      }
    }
  }
`
